"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("src/bookstore/theme");
/**
 * Styles used for react-select component
 * Note: These use the theme, and are similar to
 * but are not identical to Material UI classes
 */
exports.filledStyles = function (state) {
    var bottomBorderStyle = (function (s) {
        switch (s) {
            case 'disabled':
                return 'dotted';
            default:
                return 'solid';
        }
    })(state);
    return ({
        container: function (base) { return (__assign(__assign({}, base), { background: 'transparent' })); },
        control: function (base) { return (__assign(__assign({}, base), { 'height': 42, 'backgroundColor': theme_1.default.palette.primary.light, 'borderWidth': "0 0 2px 0 !important", 'borderColor': "transparent", 'borderRadius': '6px 6px 0 0', 'boxShadow': 'none', 'borderBottom': "2px " + bottomBorderStyle + " " + theme_1.default.palette.primary.main + " !important", '&:hover': {
                boxShadow: 'none',
            } })); },
        input: function (base) { return (__assign(__assign(__assign({}, base), theme_1.default.typography.body2), { 'color': theme_1.default.palette.text.primary, '& input': {
                font: 'inherit',
            } })); },
        valueContainer: function (base) { return (__assign(__assign(__assign({}, base), theme_1.default.typography.body2), { top: 4 })); },
        indicatorSeparator: function (base) { return (__assign(__assign({}, base), { backgroundColor: theme_1.default.palette.primary.main })); },
        dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: theme_1.default.palette.primary.main })); },
        menu: function (base) { return (__assign(__assign(__assign({}, base), theme_1.default.typography.body2), { color: theme_1.default.palette.text.secondary, backgroundColor: theme_1.default.palette.primary.light, border: "1px solid " + theme_1.default.palette.primary.main + " !important", borderRadius: 0, zIndex: 2 })); }
    });
};
